// src/features/dashboard/mocks/heatmap.mock.ts

import type {
  HeatmapApiRow,
} from '../types/heatmap.types';

/**
 * =========================================
 * HOURS
 * =========================================
 */
export const HOURS = Array.from(
  { length: 24 },
  (_, i) =>
    String(i).padStart(
      2,
      '0',
    ),
);

/**
 * =========================================
 * PEAK TIMINGS
 * =========================================
 */
export const PEAK_TIMINGS = [
  {
    label: 'Night peak',
    value: '02–04 IST',
  },
  {
    label: 'Morning peak',
    value: '10–12 IST',
  },
  {
    label: 'Evening peak',
    value: '16–18 IST',
  },
];

/**
 * =========================================
 * MOCK API RESPONSE
 * =========================================
 */
export const heatmapMockData:
  HeatmapApiRow[] = [
  {
    teamLeadId: 1,
    teamLeadName: 'John Smith',

    hc: 15,

    hour00: 5,
    hour01: 4,
    hour02: 3,
    hour03: 2,
    hour04: 2,
    hour05: 3,
    hour06: 5,
    hour07: 12,
    hour08: 25,
    hour09: 55,
    hour10: 82,
    hour11: 90,
    hour12: 88,
    hour13: 80,
    hour14: 76,
    hour15: 81,
    hour16: 87,
    hour17: 91,
    hour18: 70,
    hour19: 52,
    hour20: 35,
    hour21: 20,
    hour22: 10,
    hour23: 5,
  },

  {
    teamLeadId: 2,
    teamLeadName: 'David Wilson',

    hc: 12,

    hour00: 3,
    hour01: 3,
    hour02: 2,
    hour03: 2,
    hour04: 1,
    hour05: 2,
    hour06: 4,
    hour07: 10,
    hour08: 22,
    hour09: 48,
    hour10: 76,
    hour11: 85,
    hour12: 83,
    hour13: 79,
    hour14: 74,
    hour15: 72,
    hour16: 80,
    hour17: 86,
    hour18: 66,
    hour19: 48,
    hour20: 32,
    hour21: 18,
    hour22: 9,
    hour23: 4,
  },

  {
    teamLeadId: 3,
    teamLeadName: 'Sarah Johnson',

    hc: 18,

    hour00: 4,
    hour01: 4,
    hour02: 3,
    hour03: 3,
    hour04: 2,
    hour05: 3,
    hour06: 6,
    hour07: 15,
    hour08: 35,
    hour09: 62,
    hour10: 89,
    hour11: 95,
    hour12: 92,
    hour13: 86,
    hour14: 82,
    hour15: 85,
    hour16: 90,
    hour17: 94,
    hour18: 75,
    hour19: 58,
    hour20: 38,
    hour21: 22,
    hour22: 12,
    hour23: 6,
  },
];